export default "<ngx-spinner></ngx-spinner>\n<router-outlet></router-outlet>\n"